import React from 'react';
import PropTypes from 'prop-types';
import FilterSelectBox from '../formComponents/FilterSelectBox';
import translator from '../../translations/drupalTranslator';
import Translate from '../Translate';

const CustomerContactInfoCompSelect = (props) => {
  const getFormFieldClassName = (name, obj = props.errors) => {
    const className = 'form-field';
    if (obj[name] && obj[name].length) {
      return `${className} form-field--error`;
    }
    return className;
  };

  const validator = (data) => {
    props.validate(data)
      .then(([innerValidator, innerData]) => innerValidator(innerData),
        () => true)
      .catch(() => true);
  };


  let error = null;
  if (props.errors[props.name] && props.errorMessages[props.errors[props.name]]) {
    error = translator.translate(props.errorMessages[props.errors[props.name]]);
  }

  /* eslint-disable no-unused-vars */
  const {
    clearable,
    description,
    errorMessages,
    errors,
    onClick,
    label,
    requiredFields,
    rootClass,
    values,
    ...properties
  } = props;

  /* eslint-enable no-unused-vars */
  properties.showError = props.rootClass !== 'phone-input' && error !== null;
  properties.errorText = error;
  properties.placeholder = translator.translate(label);
  properties.required = !!props.requiredFields.find(field => field === props.name);
  properties.validate = validator;
  properties.matchPos = 'start';
  properties.openOnFocus = true;
  properties.inputProps = { id: props.name };

  return (
    <div className={getFormFieldClassName(props.name)}>
      <label
        className="form-label"
        htmlFor={props.name}
        onClick={props.onClick}
      >
        <Translate content={props.label} />
        {properties.required ? <span> &#42;</span> : null }
      </label>
      <FilterSelectBox
        className="filter-select"
        clearable={clearable}
        filteringType="start"
        name={properties.name}
        onChange={properties.onChange}
        options={properties.options}
        placeholder={properties.placeholder}
        validate={properties.validate}
        value={props.value}
        {...properties}
      />
    </div>
  );
};

CustomerContactInfoCompSelect.defaultProps = {
  rootClass: 'form-input',
};

CustomerContactInfoCompSelect.PropTypes = {
  clearable: PropTypes.bool,
  description: PropTypes.string,
  errorMessages: PropTypes.shape({}),
  errors: PropTypes.shape({}),
  label: PropTypes.string,
  loadOptions: PropTypes.func,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  })),
  requiredFields: PropTypes.shape([]),
  rootClass: PropTypes.string.isRequired,
  validate: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.number.isRequired,
  ]),
  values: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};

export default CustomerContactInfoCompSelect;
